import { BarChartInfoWrapper, Separator, SwitchContentWrapper, Title } from '../styled'

import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { SkeletonContainer } from 'pages/index-details/styled'

/**
 * Skeleton for the performance section, shown when performance section is loading
 * @returns
 */
export const PerformanceLoading: React.FC = () => {
  return (
    <SwitchContentWrapper>
      <div id="tour-chart">
        <Title>Performance</Title>
        <SkeletonContainer>
          <Skeleton height={405} borderRadius="1.5rem" />
        </SkeletonContainer>
      </div>

      <Separator />
      <BarChartInfoWrapper id="tour-returns">
        <Title>Returns</Title>
        <SkeletonContainer>
          <Skeleton height={405} borderRadius="1.5rem" />
        </SkeletonContainer>
      </BarChartInfoWrapper>
    </SwitchContentWrapper>
  )
}

export default PerformanceLoading
